import { useTranslationsContext } from 'contexts/translationsContext';
import { IconLock } from '@tabler/icons-react';

import {
	PopUpContainer,
	PopUpLink,
	PopUpTitle,
	PopUpWrapper,
	PopUpWrapperIcon,
	PopUpContent
} from './styles';

export default function UserNoPremium() {
	const { t } = useTranslationsContext();

	return (
		<PopUpContainer>
			<PopUpWrapper>
				<PopUpWrapperIcon>
					<IconLock size={32} stroke={1.5} />
				</PopUpWrapperIcon>
				<PopUpContent>
					<PopUpTitle>{t('exclusivePremiumContent')}</PopUpTitle>
					<PopUpLink
						data-ga4event-clk-name='tradingstudio_tooltip_click'
						data-ga4event-element='learn_more_about_premium'
						href={`${window.config.Variables.FxsSite}/info/premium?utm_source=trading-studio&utm_medium=internal&utm_campaign=tradingstudio-no-premium`}
						rel='noopener noreferrer nofollow'
					>
						{t('learnMoreAboutPremium')}
					</PopUpLink>
				</PopUpContent>
			</PopUpWrapper>
		</PopUpContainer>
	);
}
